import React, { useState } from "react";
import {
  CheckSquareOutlined,
  DownOutlined,
  LaptopOutlined,
  PieChartOutlined,
  ToolOutlined,
} from "@ant-design/icons";
import { Button, Dropdown, Space, Tooltip } from "antd";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { TbReport } from "react-icons/tb";
import useProfileData from "../../hooks/useProfileData";
import { checkCookie, deleteCookie } from "../../Pages/ReviewPortal/ReviewPortal.helpers";
import { IoIosLogOut } from "react-icons/io";

export default function HrNavbar() {
  const { profileData } = useProfileData();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const probationInfo = JSON.parse(localStorage.getItem("probationInfo"));
  const [isCookieAvailable, setIsCookieAvailable] = useState(() => checkCookie('rp'));

  const reviewFormLink = profileData.appraisalFormId
    ? profileData.appraisalFormId === 1
      ? `Appraisal/1?EmpId=${profileData.loginId}`
      : profileData.appraisalFormId === 2
        ? `Appraisal/2?EmpId=${profileData.loginId}`
        : profileData.appraisalFormId === 3
          ? `Appraisal/3?EmpId=${profileData.loginId}`
          : profileData.appraisalFormId === 5
            ? `Appraisal/5?EmpId=${profileData.loginId}`
            : "Appraisal/Not-Found"
    : "Appraisal/Not-Found";

  const onClick = ({ key }) => {
    // message.info(`Click on item ${key}`);
    navigate(`/${key}`, { replace: true });
  };
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const items = [
    {
      label: "Employee Master",
      key: "HR",
    },
    {
      label: "Employee Design",
      key: "HrEmpDesig",
    },
    {
      label: "Employee Dept",
      key: "HREmpDept",
    },
    {
      label: "Manage Holiday",
      key: "ManageHoliday",
    },
    {
      label: "Employee Target",
      key: "HrEmpTargetList",
    },
    {
      label: "Human Resources",
      key: "HumanResource",
    },
    {
      label: "Employee Confirmation",
      key: "HRLeave&latecomingconfirmation",
    },
  ];

  const attendance = [
    {
      label: "Mark Attendance",
      key: "Attendance/MarkAttendance",
    },
    {
      label: "Attendance Report",
      key: "Attendance/AttendanceList",
    },
    {
      label: "Request Leave",
      key: "Attendance/RequestLeave",
    },
    {
      label: "Leave History",
      key: "Attendance/LeaveHistory",
    },
    {
      label: "Subordinates Leave History",
      key: "LeaveDetail/SubordinateLeaveHistory"
    }
    // {
    //     label: 'Attendance Report',
    //     key: 'Attendance/AttendanceReport'
    // },
    // {
    //     label: 'Absent Report',
    //     key: 'Attendance/AbsentReport'
    // }
  ];
  const leaveDetails = [
    {
      label: "Employee Details",
      key: "LeaveDetail/EmployeeLeaveDetail",
    },
    {
      label: "Add New Employee",
      key: "LeaveDetail/AddNewEmployeeLeave",
    },
    {
      label: "Leave Record",
      key: "LeaveDetail/EmployeesLeaveRecord",
    },
  ];

  const appraisalItems = [
    {
      label: "Assign Employee",
      key: "Appraisal/AssignEmployee",
    },
    {
      label: "Sent Review Form",
      key: "Appraisal/SentReviewForm",
    },
    // {
    //     label: 'BackOffice Appraisal Form',
    //     key: 'Appraisal/3'
    // },
    // {
    //     label: 'PSG Appraisal Form',
    //     key: 'Appraisal/1'
    // },
    // {
    //     label: 'FAE Appraisal Form',
    //     key: 'Appraisal/5'
    // },
    // {
    //     label: 'Salesmanager Appraisal Form',
    //     key: 'Appraisal/2'
    // }
  ];
  const Kras = [
    {
      label: "My KRA",
      key: "MyKRAForm",
    },
    {
      label: "Approve KRA",
      key: "ManagerKRAapproval",
    },
  ];

  const reviewAndPerformace = [
    // {
    //   label: "My Review Form",
    //   key: reviewFormLink,
    // },
    // {
    //   label: "Manager Audit",
    //   key: "Appraisal/ManagerAuditEmpList",
    // },
    {
      label: "HR Review",
      key: "Appraisal/HrReview",
    },
    {
      label: "HR Final Review",
      key: "Appraisal/HrFinalReview",
    },
  ];

  const hrUserAppraisalLinks = [
    {
      label: "My Review Form",
      key: reviewFormLink,
    },
    {
      label: "Manager Audit",
      key: "Appraisal/ManagerAuditEmpList",
    },
  ]

  const training = [
    {
      label: "Schedule Training",
      key: "Training/Schedule",
    },
    {
      label: "Training Feedback",
      key: "Training/Feedback",
    },
    {
      label: "Suggesstions",
      key: "Training/Suggestions",
    },
    {
      label: "Training Details",
      key: "Training/Details",
    },
  ];

  const reimbursement = [
    {
      label: "Reimbursement",
      key: "Reimbursement",
    },
    {
      label: "List",
      key: "Reimbursement/List",
    },
  ];

  const info = [
    {
      label: "Subordinate Resignation List",
      key: "ResignationInfo/ReportingHeadList",
      isVisible: true
    },
    {
      label: "Resignation Status",
      key: "ResignationInfo/ResignationStatus",
      isVisible: userData.isResigned
    }
  ].filter(item => item.isVisible);

  const settings = [
    {
      label: "Incentive Master",
      key: 'IncentiveMaster/ExtraIncentive',
    }
  ];

  return (
    <div className="dropdown-navbar">
      <Dropdown
        menu={{
          items,
          onClick,
        }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{
            color: "black",
            fontSize: "13px",
            fontWeight: 600,
            marginLeft: "0.75rem",
          }}
        >
          <Space>
            <ToolOutlined /> Human Resources <DownOutlined />
          </Space>
        </a>
      </Dropdown>
      {pathname.includes("/Attendance") && (
        <Dropdown
          menu={{
            items: attendance,
            onClick,
          }}
        >
          <a
            onClick={(e) => e.preventDefault()}
            style={{
              color: "black",
              fontSize: "13px",
              fontWeight: 600,
              marginLeft: "0.75rem",
            }}
          >
            <Space>
              <ToolOutlined />
              Attendance Details
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>
      )}
      <Dropdown
        className="mx-1"
        menu={{
          items: leaveDetails,
          onClick,
        }}
      >
        <a
          style={{ color: "black", fontSize: "13px", fontWeight: 600 }}
          onClick={(e) => e.preventDefault()}
        >
          <Space>
            <ToolOutlined />
            <span>Leave Details</span>
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>

      <Dropdown
        className="mx-3"
        menu={{
          items: Kras,
          onClick,
        }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{ color: "black", fontSize: "13px", fontWeight: 600 }}
        >
          <Space>
            <PieChartOutlined />
            KRA
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>

      {/* <Dropdown
        className="mx-1"
        menu={{
          items: appraisalItems,
          onClick,
        }}
      >
        <a
          style={{ color: "black", fontSize: "13px", fontWeight: 600 }}
          onClick={(e) => e.preventDefault()}
        >
          <Space>
            <ToolOutlined />
            <span>Appraisal</span>
            <DownOutlined />
          </Space>
        </a>
      </Dropdown> */}

      {/* <Dropdown
        menu={{
          items: training,
          onClick,
        }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{ color: "black", fontSize: "13px", fontWeight: 600 }}
        >
          <Space>
            <ToolOutlined />
            Training
            <DownOutlined />
          </Space>
        </a>
      </Dropdown> */}

      {/* <Dropdown
        menu={{
          items: reimbursement,
          onClick,
        }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{ color: "black", fontSize: "13px", fontWeight: 600 }}
        >
          <Space>
            <ToolOutlined />
            Reimbursement
            <DownOutlined />
          </Space>
        </a>
      </Dropdown> */}
      {
        probationInfo && probationInfo?.isOnProbation && !(userData.isResigned) && (
          <Link
            to="/Confirmation/CheckProbation"
            style={{
              color: "black",
              fontSize: "13px",
              fontWeight: 600,
              marginLeft: "0.75rem",
            }}
          >
            <Space>
              <CheckSquareOutlined />
              Probation
            </Space>
          </Link>
        )
      }

      <Link
        to="/QPI/List"
        style={{
          color: "black",
          fontSize: "13px",
          fontWeight: 600,
          marginLeft: "0.75rem",
        }}
      >
        <Space>
          <LaptopOutlined />
          QPI Calculator
        </Space>
      </Link>

      {
        !isCookieAvailable && (
          <Link
            to="/ReviewPortal"
            style={{
              color: "black",
              fontSize: "13px",
              fontWeight: 600,
              marginLeft: "0.75rem",
            }}
          >
            <Space>
              <LaptopOutlined />
              Review Portal
            </Space>
          </Link>
        )
      }

      {/* <Link
                to="/WeeklyReport"
                style={{
                    color: "black",
                    fontSize: "13px",
                    fontWeight: 600,
                    marginLeft: "0.75rem",
                }}
            >
                <Space>
                    <TbReport />
                    Weekly Report
                </Space>
            </Link> */}

      {
        info.length > 0 && (
          <Dropdown
            menu={{
              items: info,
              onClick,
            }}
          >
            <a
              onClick={(e) => e.preventDefault()}
              style={{
                color: "black",
                fontSize: "13px",
                fontWeight: 600,
                marginLeft: "0.75rem",
              }}
            >
              <Space>
                <ToolOutlined />
                Info
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>
        )
      }

      <Dropdown
        menu={{
          items: hrUserAppraisalLinks,
          onClick,
        }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{
            color: "black",
            fontSize: "13px",
            fontWeight: 600,
            marginLeft: "0.75rem",
          }}
        >
          <Space>
            <ToolOutlined />
            My Review
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>

      {
        isCookieAvailable && (
          <Dropdown
            menu={{
              items: [...appraisalItems, ...reviewAndPerformace],
              onClick,
            }}
          >
            <a
              onClick={(e) => e.preventDefault()}
              style={{
                color: "black",
                fontSize: "13px",
                fontWeight: 600,
                marginLeft: "0.75rem",
              }}
            >
              <Space>
                <ToolOutlined />
                Appraisal & Review
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>
        )
      }


      {
        isCookieAvailable && (
          <Tooltip title="Logout from Appraisal View">
            <Button
              style={{ marginLeft: '1rem' }}
              type="primary"
              onClick={() => {
                deleteCookie('rp');
                setIsCookieAvailable(false);
                navigate('/Dashboard');
              }}>
              <IoIosLogOut />
            </Button>
          </Tooltip>
        )
      }

      <Dropdown
        menu={{
          items: settings,
          onClick,
        }}
      >
        <a
          onClick={(e) => e.preventDefault()}
          style={{
            color: "black",
            fontSize: "13px",
            fontWeight: 600,
            marginLeft: "0.75rem",
          }}
        >
          <Space>
            <ToolOutlined />
            Settings
            <DownOutlined />
          </Space>
        </a>
      </Dropdown>
    </div>
  );
}
